import axios from "axios";
import { useState } from "react";
import { errorNotify, successNotify } from "../../../Services/Notification";
import MirageLoader from "../../ui/pageLoader/MirageLoader";
import BackDrop from "../../ui/BackDrop";
import { closeIcon, fileUploadIcon } from "../../../assetData/icons";

const uploadSettlementCalendarUploadAPI = `${process.env.REACT_APP_API_URL}api/upload-settlement-calender/`;

const SettlementCalendarUpload = ({ triggerRerender, setisPopupOpen }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [isButtonClicked, setIsButtonClicked] = useState(false);

  const closeHandler = () => {
    setisPopupOpen(false);
  };

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleFileUpload = async () => {
    setIsButtonClicked(true);
    if (selectedFile) {
      try {
        const formData = new FormData();
        formData.append("file", selectedFile);

        // Only include Authorization header, let browser set Content-Type automatically
        const headers = {
          Authorization: `Bearer ${
            sessionStorage.getItem("subscriberToken")
              ? sessionStorage.getItem("subscriberToken")
              : sessionStorage.getItem("token")
          }`,
          // Remove Content-Type header - browser will set it automatically for FormData
        };

        const res = await axios.post(
          uploadSettlementCalendarUploadAPI,
          formData,
          {
            headers,
          },
        );

        if (!res?.data?.error) {
          successNotify("File uploaded successfully.");
          closeHandler();
          setIsButtonClicked(false);
          triggerRerender();
        } else {
          errorNotify(res?.data?.message || "File upload failed.");
          setIsButtonClicked(false);
        }
      } catch (error) {
        console.log("File upload error:", error);
        errorNotify(error?.response?.data?.error || "File upload failed.");
        setIsButtonClicked(false);
      }
    } else {
      errorNotify("Please select a file to upload.");
      setIsButtonClicked(false);
    }
  };

  return (
    <>
      <div className="fixed left-1/2 top-1/2 z-20 mx-auto min-h-[300px] max-w-[1200px] -translate-x-1/2 -translate-y-1/2 rounded bg-white p-8 max-md:w-full md:w-[500px]">
        <h2 className="pb-4 text-2xl font-bold text-neutral-800">
          Upload Settlement Calendar
        </h2>

        <button
          type="button"
          className="absolute top-8 max-md:right-2 md:right-8"
          onClick={closeHandler}
        >
          <img src={closeIcon} />
        </button>

        <div className="mt-8 flex gap-2 ">
          <div className="w-full space-y-4">
            <label className="text-[#000]">Document to upload</label>
            <div className="relative overflow-hidden rounded-lg max-md:w-full md:w-full">
              <input
                type="file"
                className="custom-doc-uploader  bg-[#FAFAFA] text-neutral-600"
                onChange={handleFileChange}
              />
              <img
                src={fileUploadIcon}
                className="absolute left-4 top-1/2 z-10 -translate-y-1/2"
              />
            </div>

            <div className="flex items-center justify-center gap-2  max-sm:[&>button]:w-full sm:[&>button]:w-1/2">
              <button
                type="submit"
                disabled={isButtonClicked}
                className={` ${
                  isButtonClicked ? "opacity-[70%]" : ""
                } mt-8 w-full rounded border-2 border-pri-clr-orange bg-pri-clr-orange  py-2 font-semibold text-white`}
                onClick={handleFileUpload}
              >
                {isButtonClicked ? <MirageLoader /> : "IMPORT"}
              </button>
            </div>
          </div>
        </div>
      </div>
      <BackDrop closeHandler={closeHandler} />
    </>
  );
};

export default SettlementCalendarUpload;
